exports.install = function (Vue) {

    Vue.prototype.loadLanguage = function() {
        const lang = require('./lang/' + this.$root.$data.state.lang + '.json');
        this.$root.$data.state.translation = lang;
        this.$root.$data.state.languageActive = true;
    }

};